export const ACTIVATE_UTR_CLEAR_DATA = 'ACTIVATE_UTR_CLEAR_DATA';
export const ACTIVATE_UTR_AUTHENTICATE = 'ACTIVATE_UTR_AUTHENTICATE';
export const ACTIVATE_UTR_AUTHENTICATE_SUCCESS = 'ACTIVATE_UTR_AUTHENTICATE_SUCCESS';
export const ACTIVATE_UTR_AUTHENTICATE_FAILED = 'ACTIVATE_UTR_AUTHENTICATE_FAILED';
export const CONNECT_PLAYER_THIRD_PARTY_ID = 'CONNECT_PLAYER_THIRD_PARTY_ID';
export const CONNECT_PLAYER_THIRD_PARTY_ID_SUCCESS = 'CONNECT_PLAYER_THIRD_PARTY_ID_SUCCESS';
export const CONNECT_PLAYER_THIRD_PARTY_ID_FAILURE = 'CONNECT_PLAYER_THIRD_PARTY_ID_FAILURE';
